import Modal from "../../scripts/modal";
import SiteMessagesInstance from "../../components/site-messages";
import merge from "lodash.merge";
import modalDeleteSensorsGroup from "./modal-delete-group";

const modalEditSensorsGroup = (settings = {}) => {
  settings = merge({
    class: ['group-modal', 'form-modal'],
    title: 'Group Settings',
  }, settings);

  const group = settings.group;

  const modal = new Modal(settings);

  modal.setContent(`
    <form data-form="edit_sub_account" class="grid-container">
      <div class="grid-x grid-margin-x form-modal__row">
        <div class="cell medium-2">Name</div>
        <div class="cell medium-8">
          <input type="text" required value="${group.group_name.replace(/"/g, '\"')}" name="group_name" placeholder="Group name" />
        </div>
      </div>

      <div class="form-modal-actions" style="display: flex;">
        <div class="form-modal-actions__submit" style="flex:1;">
          <button type="submit" class="button" style="margin-right:20px;" data-for="okay">Update Group</button>
          <button type="button" class="button gray" data-for="cancel">Cancel</button>
          <div class="error-message"></div>
        </div>
        <div class="form-modal-actions__delete" style="width: 120px; text-align: right;">
          <button type="button" class="button button--delete" data-action="delete">Delete Group</button>
        </div>
      </div>
    </form>
  `);

  const $modalContainer = $(modal.getContainer());
  const $form = $modalContainer.find('form');
  const $error = $modalContainer.find('.error-message');

  $form.on('submit', async e => {

    e.preventDefault();

    const name = $modalContainer.find('input[name="group_name"]').val();

    if(name == group.group_name) {
      // do nothing
      modal.close();
      return;
    }

    $form[0].disabled = true;
    $error.removeClass('is-visible');

    const r = await window.apiRequest('post', `/groups/sensors/${group.id}/edit`, {
      group_name: name,
    });

    $form[0].disabled = false;

    if (r.type === 'error') {

      $error.html(r.message);
      $error.addClass('is-visible');

    } else {
      SiteMessagesInstance.addMessage('success', r.message);
      SiteMessagesInstance.displayMessages();
      modal.close();
    }

  });

  $modalContainer.on('click', '.button[data-action="delete"]', () => {
    modal.close()

    modalDeleteSensorsGroup({
      group,
    });

  });

  $modalContainer.on('click', '.button[data-for="cancel"]', () => modal.close());
  modal.open();

};

export default modalEditSensorsGroup;
